import { ref, watch, onUnmounted } from 'vue';
import ExceptionCasesAPI from 'dashboard/api/exceptionCases';

export const EXCEPTIONS_CHANGED_EVENT = 'borderchat:exceptions-changed';

export function useExceptionCount(accountId, userId) {
  const count = ref(0);
  let request = 0;

  const refresh = async () => {
    const id = accountId.value;
    request += 1;
    const serial = request;
    if (!id || !userId.value) return;
    try {
      const { data } = await ExceptionCasesAPI.get(id, {
        counts_only: true,
        status: 'active',
        historical: false,
      });
      if (serial === request) count.value = data.meta.total_count;
    } catch {
      // Do not present an old account's count, or a stale count after a failure.
      if (serial === request) count.value = 0;
    }
  };

  watch(
    [accountId, userId],
    () => {
      count.value = 0;
      refresh();
    },
    { immediate: true }
  );

  const onChange = event => {
    if (String(event.detail.accountId) === String(accountId.value)) refresh();
  };
  const onFocus = () => refresh();
  window.addEventListener(EXCEPTIONS_CHANGED_EVENT, onChange);
  window.addEventListener('focus', onFocus);
  const timer = window.setInterval(() => {
    if (!document.hidden) refresh();
  }, 60000);
  onUnmounted(() => {
    request += 1;
    window.clearInterval(timer);
    window.removeEventListener(EXCEPTIONS_CHANGED_EVENT, onChange);
    window.removeEventListener('focus', onFocus);
  });

  return count;
}
